import {apiSlice} from "../../app/apiSlice";

export interface EDSTag {
    name: string;
    value: string;
}

export interface EDS {
    id: string;
    name: string;
    displayName: string;
    description: string;
    createdBy: string;
    environment: string;
    mode: string;
    type: string;
    label: string;
    phase: string;
    tags: EDSTag[]
}

export const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder => ({
        getEdsList: builder.query<EDS[], { edsType: string, tagFilters?: string, env: string } >({
            query: ({edsType, tagFilters, env}) => `/sap/eds?edstype=${edsType}&env=${env}${tagFilters ? `&filtertags=${tagFilters}` : ''}`,
            keepUnusedDataFor:0
        }),
    })),
    overrideExisting: false
})


export const {
    useGetEdsListQuery
} = extendedApi